/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

const form = require('b_').with('form');
const input = require('b_').with('input');

export const FormGroup = ({
    title, children, mod, required,
}) => (
    <div className={form('group', mod)}>
        {title && (
            <header className={form('group-header')}>
                <span className={input('label', { required })}>{title}</span>

            </header>
        )}
        {children}
    </div>
);
